import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpBackend, HttpHeaders } from '@angular/common/http';
import { VariablesGlobales as Data } from '../../models/variablesGlobales.model';


import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';



@Injectable()
export class AppLoadService {
  url2=environment.api;
  
  constructor(private httpClient: HttpClient,handler: HttpBackend, @Inject(PLATFORM_ID) private platformId: Object) { 
    this.httpClient = new HttpClient(handler);
  }
  async getDataPriory(): Promise<any> {
      var reqHeader = new HttpHeaders();
      if(isPlatformBrowser(this.platformId)){
        try {
          let calls:any[] = [];
          calls.push(this.httpClient.get(`${environment.api}services/ip.php`, { headers: reqHeader }));
          const res:any = await forkJoin(calls).toPromise();
          Data._idEquipo = res[0].IP;          
          return {op:"OK",mensaje:null};
        } catch(err) {
          Data._idEquipo = '192.168.1.1';
          return {op:"ERR",mensaje:"Error al cargar datos prioritarios..."};
        } 
      }else{
        Data._idEquipo = '192.168.1.1';
        return {op:"ERR",mensaje:"Error al cargar datos prioritarios..."};
      }
  }
}
